import {getDistance} from "geolib";
import gmaps from "./global-gmaps";

export default {
    getDistance(origin, destinaton) {
        return getDistance(origin, destinaton)
    },
    getLatLng(addressSearchString) {
        return new Promise((resolve, reject) => {
            gmaps().then(google => {
                // TODO: country: 'DE' könnte man hier mal einbauen
                new google.maps.Geocoder().geocode({address: addressSearchString}, function(results, status) {
                    if (status === 'OK') {
                        resolve({
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng()
                        });
                    } else {
                        reject(status);
                    }
                })
            })
        });
    },
    normalizeLatLng(coord) {
        if (typeof coord === 'string') {
            return Math.round(coord * 10000) / 10000;
        }
        return {lat: Math.round(coord.lat * 10000) / 10000, lng: Math.round(coord.lng * 10000) / 10000} ;
    },
    convertStringToGoogleLatLng(latLngString, delimiter = ',') {
        const coords = latLngString.split(delimiter);
        return {lat: Number(coords[0]), lng: Number(coords[1])}
    },
    convertToGoogleLatLng(lat, lng) {
        return {lat: Number(lat), lng: Number(lng)}
    }
}
